<template>
  <div class="ew-vbarchart">
    <div class="ew-vbarchart__empty" v-if="!items || items.length === 0">
      {{ emptyText }}
    </div>
    <div class="ew-vbarchart__plot" v-else>
      <div class="ew-vbarchart__col" v-for="(item, i) in items" :key="item.label" :title="`${item.label}: ${item.value}`">
        <span class="ew-vbarchart__value">{{ item.value }}</span>
        <div class="ew-vbarchart__track">
          <div
            class="ew-vbarchart__bar"
            :class="{ 'ew-vbarchart__bar--emphasis': i === 0 }"
            :style="{ height: barHeight(item.value) + '%' }"
          ></div>
        </div>
        <span class="ew-vbarchart__label">{{ item.label }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VerticalBarChart',
  props: {
    items: {
      type: Array,
      default: () => []
    },
    emptyText: {
      type: String,
      default: 'Sin datos en este periodo'
    }
  },
  computed: {
    maxValue () {
      return this.items && this.items.length > 0
        ? Math.max(...this.items.map((item) => item.value))
        : 0
    }
  },
  methods: {
    barHeight (value) {
      if (!this.maxValue) return 0
      return Math.max((value / this.maxValue) * 100, 4)
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../assets/styles/app-tokens";

.ew-vbarchart {
  @include app-tokens;
}

.ew-vbarchart__plot {
  display: flex;
  align-items: flex-end;
  justify-content: center;
  gap: 2rem;
  height: 12rem;
  padding-top: 1.5rem;
}

.ew-vbarchart__col {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  width: 4.5rem;
}

.ew-vbarchart__value {
  font-family: var(--app-font);
  font-size: 0.82rem;
  font-weight: 700;
  color: var(--app-navy);
  margin-bottom: 0.4rem;
}

.ew-vbarchart__track {
  flex: 1 1 auto;
  width: 100%;
  display: flex;
  align-items: flex-end;
  border-bottom: 1px solid var(--app-border);
}

.ew-vbarchart__bar {
  width: 100%;
  max-width: 2.25rem;
  margin: 0 auto;
  background: var(--app-muted);
  border-radius: 4px 4px 0 0;
  transition: filter 0.15s ease;
}

.ew-vbarchart__bar--emphasis {
  background: var(--app-accent-button);
}

.ew-vbarchart__col:hover .ew-vbarchart__bar {
  filter: brightness(0.92);
}

.ew-vbarchart__label {
  margin-top: 0.5rem;
  font-family: var(--app-font);
  font-size: 0.8rem;
  color: var(--app-navy-secondary);
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

.ew-vbarchart__empty {
  font-family: var(--app-font);
  font-size: 0.85rem;
  color: var(--app-muted);
  padding: 0.75rem 0;
}
</style>



// WEBPACK FOOTER //
// src/components/charts/VerticalBarChart.vue